export var menuWidth = 250;
export var handleWidth = 50;
export var menuPadding = 16;
export var buttonWidth = 250 - 16 * 2;